import { FieldProps } from 'formik'
import * as React from 'react'

import { QuestionWrapper } from '../form.styles'
import { ErrorMessage, InputField, Label, Wrapper } from './Input.styles'

interface Props extends React.InputHTMLAttributes<any> {
  value?: any
  label: string
  name: string
  text?: string
  hasError?: boolean
  errorMsg?: string
  required?: boolean
  onInputChange?: (event) => void
}

interface State {
  hasFocus: boolean
  value: string
}

class Input extends React.Component<Props & FieldProps<any>, State> {
  constructor(props) {
    super(props)
    if (props.value) {
      this.state = { hasFocus: false, value: props.value }
    } else {
      const formValue = props.form.values[props.field.name]
      const value = formValue ? formValue : ''
      this.state = { hasFocus: false, value }
    }
  }

  onFocus = () => {
    this.setState({ hasFocus: true })
  }

  onBlur = () => {
    this.setState({ hasFocus: false })
  }

  onChange = event => {
    let currentValue = event.currentTarget.value

    if (this.props.type === 'number' && Number(currentValue) > 0) {
      currentValue = Number(currentValue)
    }
    this.setState({ value: currentValue })
    if (this.props.onInputChange) this.props.onInputChange(event)
    this.props.form.handleChange(event)
  }

  render() {
    const {
      label,
      type = 'text',
      text,
      required = false,
      field,
      form,
    } = this.props
    const { value, hasFocus } = this.state
    const numericValue = Number(value)
    const hasValue = Boolean(value)
    const hasError = Boolean(
      (form.touched[field.name] || hasValue) &&
        !hasFocus &&
        form.errors[field.name],
    )

    return (
      <>
        <QuestionWrapper as="div" color="black">
          {text}
        </QuestionWrapper>

        <Wrapper>
          <Label required={required} elevated={hasValue || hasFocus}>
            {label}
          </Label>
          <InputField
            name={field.name}
            type={
              type !== 'number' && type !== 'tel' && type !== 'text'
                ? type
                : 'text'
            }
            value={this.state.value}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            hasError={hasError}
          />
        </Wrapper>
        {hasError && <ErrorMessage>{form.errors[field.name]}</ErrorMessage>}
      </>
    )
  }
}

export default Input
